import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Const} from '../const/const';
import {Observable} from 'rxjs';
import {Country} from '../models/country.model';


@Injectable({
  providedIn: 'root'
})
export class CountriesService {
  constructor(private http: HttpClient) {}

  findAll(): Observable<Country[]> {
    return this.http.get<Country[]>(Const.baseAPI + '/countries/all');
  }
}
